import { type ClockTimeFormat, HourMinutesSecondsMillis } from "@suse-o11y/date-time/format/clock-time-format";
import { formatAbsoluteTime } from "@suse-o11y/date-time/format/format-absolute-time";
import { formatViewTime } from "@suse-o11y/date-time/format/format-view-time";
import type { Time } from "@suse-o11y/date-time/time";
import { Tooltip, TooltipBoundary, TooltipTrigger } from "@suse-o11y/tooltip";
import { useNow } from "@suse-o11y/use-now";
import React from "react";
import { useSelector } from "react-redux";

import { selectTimestampDate } from "../../../app/state/view/timeline/TimelineSelectors";

export interface ViewTimeProps {
	time: Time;
	tooltip?: React.ReactNode;
	hideTooltip?: boolean;
	clockTimeFormat?: ClockTimeFormat;
	className?: string;
}

/**
 * Formats time relative to the current moment (now) and the selected view time.
 */
export const FormatViewTime: React.FC<ViewTimeProps> = ({
	time,
	tooltip,
	hideTooltip,
	clockTimeFormat,
	...restProps
}) => {
	const viewTime = useSelector(selectTimestampDate);
	const formattedTime = useNow({
		transform: (now) => formatViewTime({ time, viewTime: viewTime ?? now, now, clockTimeFormat }).toString(),
	});

	return (
		<TooltipBoundary hide={hideTooltip}>
			<TooltipTrigger asChild>
				<span data-testid="format-view-time" {...restProps}>
					{formattedTime}
				</span>
			</TooltipTrigger>

			<Tooltip className="tooltip/tooltip">
				{tooltip ?? formatAbsoluteTime(time, { clockTimeFormat: HourMinutesSecondsMillis }).toString()}
			</Tooltip>
		</TooltipBoundary>
	);
};
